import ThemeSwitch from '@/components/ThemeSwitch'
import SideMenuFooter from './SideMenuFooter'
import SideMenuItem from './SideMenuItem'
import { useRouter } from 'next/router'
import { useState } from 'react'
import sideMenuItemsData from '@/data/sideMenuItemsData'

export default function SideMenuContent({ setShowSideMenu }) {
  const router = useRouter()
  const [selectedPage, setSelectedPage] = useState(router.asPath)

  return (
    <>
      <div className="flex h-full w-full flex-col justify-between">
        <div className="flex flex-col space-y-20">
          <div className="flex flex-row justify-between">
            <h2 className="prose ml-1 text-2xl font-semibold dark:prose-dark">Explore</h2>
            <ThemeSwitch />
          </div>
          <ul className="flex flex-col space-y-2">
            {sideMenuItemsData.map((item) => (
              <SideMenuItem
                key={item.page}
                selected={selectedPage === item.page}
                text={item.title}
                page={item.page}
                setShowSideMenu={setShowSideMenu}
                setSelectedPage={setSelectedPage}
              />
            ))}
          </ul>
        </div>
        <SideMenuFooter setShowSideMenu={setShowSideMenu} />
      </div>
    </>
  )
}
